import palette from "../palette";

export default {
  root: {
    color: palette.icon,
    "&:hover": {
      opacity: 0.75
    }
  }
};
